import { useNavigate } from "react-router";

export default function Header({
    pageTitle,
    items = [],
    hasBack = false,
    backLinkClickHandler = null,
    buttons = null,
    headerClassName = null
}) {
    const navigate = useNavigate();
    const onBacklLinkClick = (event, url) => {
        if (backLinkClickHandler) backLinkClickHandler(url, event);
        else navigate(url);
    };

    return (
        <>
            <div className="flex justify-between items-center">
                <div className="flex items-center gap-x-3 justify-between w-full">
                    <span className={`text-xl font-semibold ${headerClassName}`}>{pageTitle}</span>
                    {hasBack ? (
                        <div
                            className="flex items-center gap-x-1 cursor-pointer"
                            onClick={(event) =>
                                onBacklLinkClick(event, items[0]?.url)
                            }
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                className="w-4 h-4"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"
                                />
                            </svg>
                            <p className="text-sm font-medium text-blue-500">
                                Back
                            </p>
                        </div>
                    ) : null}
                    {buttons}
                </div>
            </div>
        </>
    );
}
